<div *adaptLoadingUntilFirstEmit="let categories of categories$">
    @for (category of categories; track category) {
        @if (editMode || !category.isEmpty) {
            <adapt-dashboard-element name="{{ category.category.label }}">
                @if (editMode) {
                    <div adapt-dashboard-title-buttons>
                        <button adaptButton="editBorderless"
                                [disabled]="disabled"
                                (click)="editProfileItem(category)"></button>
                    </div>
                }
                @for (item of category.items; track item) {
                    @if (editMode || (item.value && !item.value.isEmpty)) {
                        <div class="profile-category-item">
                            <h4>
                                {{ item.item.label }}
                                @if (item.item.isPrivate) {
                                    <small class="fal fa-lock-alt"
                                           adaptTooltip="This information is only visible to you and those with permission to view private profile data"></small>
                                }
                            </h4>
                            @if (item.value && !item.value.isEmpty) {
                                <div>
                                    @if (item.value.text) {
                                        <div [froalaView]="item.value.text"></div>
                                    }
                                    @if (item.value.date) {
                                        <div>
                                            {{ item.value.date | adaptDate }}
                                        </div>
                                    }
                                </div>
                            } @else {
                                <small>No value set</small>
                            }
                        </div>
                    }
                }
            </adapt-dashboard-element>
        }
    }
</div>
